import { render, staticRenderFns } from "./MerchantSidebar.vue?vue&type=template&id=d4dd8b5a&scoped=true"
import script from "./MerchantSidebar.vue?vue&type=script&lang=js"
export * from "./MerchantSidebar.vue?vue&type=script&lang=js"
import style0 from "./MerchantSidebar.vue?vue&type=style&index=0&id=d4dd8b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dd8b5a",
  null
  
)

export default component.exports